module.exports = __webpack_public_path__ + "img/Support-skill-407.c0a6dc71.png";